import PropTypes from 'prop-types';

import { Colors } from '@spotahome/ui-library';

const theme = {
  base: Colors.primary,
  light: 'white',
  interaction: Colors.interaction,
  interactionDark: Colors['interaction-dark']
};

const Map = props => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.00008 14L11.1249 9.89947C11.9407 9.08846 12.4963 8.05518 12.7213 6.93029C12.9464 5.8054 12.8309 4.63942 12.3894 3.5798C11.9479 2.52017 11.2002 1.6145 10.2409 0.977301C9.28161 0.340103 8.1538 0 7.00008 0C5.84636 0 4.71855 0.340103 3.75926 0.977301C2.79998 1.6145 2.05231 2.52017 1.61079 3.5798C1.16928 4.63942 1.05376 5.8054 1.27883 6.93029C1.50391 8.05518 2.05947 9.08846 2.87527 9.89947L7.00008 14ZM7.00008 7.4375C7.99136 7.4375 8.79495 6.654 8.79495 5.6875C8.79495 4.721 7.99136 3.9375 7.00008 3.9375C6.0088 3.9375 5.20521 4.721 5.20521 5.6875C5.20521 6.654 6.0088 7.4375 7.00008 7.4375Z"
      fill={theme[props.theme]}
    />
  </svg>
);

Map.propTypes = {
  theme: PropTypes.oneOf(['base', 'light', 'interaction'])
};

Map.defaultProps = {
  theme: 'base'
};
export default Map;
